import React from "react";
import { getLocalStorageValue } from "config/helper";

const ComponentToPrintTheme2 = React.forwardRef((props, ref) => {
  const barcodeImage = getLocalStorageValue("user-barcode");
  return (
    <>
      <div ref={ref}>
        {" "}
        <img
          alt="Barcode"
          src={barcodeImage ? barcodeImage : ""}
          style={{ marginLeft: "108px", marginTop: "200px" }}
        />
      </div>
    </>
  );
});
export default ComponentToPrintTheme2;
